export type Subject = {
    name: string;
    id: string;
    numberId?: string;
    label: string;
    value: string;
    newStandardId?: number;
};

type SubjectDefinition = Omit<Subject, "label" | "value">;

const createSubjects = (subjects: SubjectDefinition[]): Subject[] =>
    subjects.map((subject) => ({
        ...subject,
        label: subject.name,
        value: subject.numberId ?? subject.id,
    }));

const subjectsByType: Record<string, Subject[]> = {
    bac: createSubjects([
        {name: "Bacalaureat Știinte/Tehnic", id: "bac-mate", numberId: "901"},
        {name: "Bacalaureat Matematică/Informatică", id: "bac-mate-info", numberId: "902"},
        {name: "Bacalaureat Română", id: "bac-romana", numberId: "903"},
        {name: "Bacalaureat Istorie", id: "bac-istorie", numberId: "904"},
    ]),

    evaluate: createSubjects([
        {name: "Evaluare Națională Matematică (VIII)", id: "evaluare-nationala-mate", numberId: "48"},
        {name: "Evaluare Națională Română (VIII)", id: "evaluare-nationala-romana", numberId: "39"},
    ]),

    school: createSubjects([
        {name: "Comunicare în limba română (CLR)", id: "CLR", newStandardId: 1},
        {name: "Limba și literatura română", id: "4", newStandardId: 2},
        {name: "Matematică și explorarea mediului", id: "MEM", newStandardId: 3},
        {name: "Matematică", id: "1", newStandardId: 4},
        {name: "Istorie", id: "22", newStandardId: 5},
        {name: "Geografie", id: "37", newStandardId: 6},
        {name: "Biologie", id: "33", newStandardId: 7},
        {name: "Chimie", id: "34", newStandardId: 8},
        {name: "Fizică", id: "30", newStandardId: 9},
    ]),

    numericLiteracyPrimary: createSubjects([
        {name: "Test rapid", id: "fast"},
        {name: "Test evaluare", id: "evaluate"},
        {name: "Test screener ICAN (I-IV)", id: "ican"},
    ]),

    numericLiteracy: createSubjects([
        {name: "Test rapid", id: "fast"},
        {name: "Test evaluare", id: "evaluate"},
    ]),
};

subjectsByType.training = subjectsByType.school;

export const getSubjects = (type?: string): Subject[] =>
    subjectsByType[type ?? ""] ?? [];
